import { RootState } from '@iwProvider/configureStore';
import { H3 } from '@ui';
import { FormattedMessage, FormattedDate } from 'react-intl';
import { connect } from 'react-redux';

import messages from './NextRepayment.messages';
import {
    getDrawdownNextRepaymentAmount,
    getDrawdownNextRepaymentDate
} from '../../../../../api/repaymentScheduleSelector';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';

const mapStateToProps = (state: RootState) => ({
    nextRepaymentAmount: getDrawdownNextRepaymentAmount(state),
    nextRepaymentDate: getDrawdownNextRepaymentDate(state)
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const NextRepayment = ({
    nextRepaymentAmount,
    nextRepaymentDate
}: PropsFromRedux) => {
    return (
        <div>
            <H3 className="mb-m text-m font-med min-l:mb-xl">
                <FormattedMessage {...messages.firstRepayment} />
            </H3>

            <SummaryRow className="mb-m min-l:mb-xl">
                <MoneyWithDecimals
                    className="text-2xl min-l:text-5xl"
                    value={nextRepaymentAmount}
                    decimalWithSeparatorClassName="min-l:text-xl"
                />
                <FormattedDate
                    value={new Date(nextRepaymentDate)}
                    day="numeric"
                    month="long"
                    year="numeric"
                />
            </SummaryRow>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(NextRepayment);
